import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/tailwind.css'
import './assets/main.css'
import App from './App';
import { ScreenSizeProvider } from './components/ScreenSizeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ScreenSizeProvider>
      <App />
      </ScreenSizeProvider>
  </React.StrictMode>
);
